export default "__VITE_ASSET__BhZ0oYZe__"